import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Opens every new page at the top. Clicking a link keeps the old page's scroll position otherwise,
// because the router swaps the content without a real page load. Links to a section (#hash) are
// left to the page that owns the section, and Back/Forward are left to the browser.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP" || hash) return;
    window.scrollTo(0, 0);
    // Only a new page should scroll; a hash change on the same page is the page's own business.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}

export default ScrollToTop;
